<template>
  <div class="grid px-3 py-4">
    <div id="edutable">
      <p class="text-xl text-blue-400 font-medium">Languages Known :</p>
    </div>
    <div class="overflow-y-auto">
      <table class="table w-full">
        <thead>
          <tr>
            <th></th>
            <th>Languages</th>
            <th>Speak</th>
            <th>Read</th>
            <th>Write</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, i) in languages" :key="i">
            <th scope="row">{{ ++i }}</th>
            <td>{{ entry.Language }}</td>
            <td>{{ entry.Speak }}</td>
            <td>{{ entry.Read }}</td>
            <td>{{ entry.Write }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang",
  computed: {
    languages() {
      return this.$store.state.Candidate.application.languages;
    },
  },
};
</script>
